import moment from 'moment-timezone';
import React from 'react';

import { Modal } from 'components/v2/Modal/Modal';
import { Appointment } from 'kb-shared';

import { CancellationPolicy } from './CancellationPolicy/CancellationPolicy';

type Props = {
  show: boolean;
  onClickClose: () => void;
  appointment?: Appointment | null;
};

export const CancellationPolicyModal = (props: Props) => {
  const { show, onClickClose, appointment } = props;
  const emailBody = appointment
    ? `&body=%0D%0A%0D%0A%0D%0A%0D%0AAppointment # ${appointment.id}%0D%0A${moment(
        appointment.startTime
      ).format('dddd MMMM d, h:mm A z')}`
    : '';
  return (
    <Modal title="Cancellation Policy" open={show} onCancel={onClickClose}>
      <CancellationPolicy
        emailBody={emailBody}
        noCancelNorRescheduleVariant={
          appointment != null && !appointment.cancelable && !appointment.reschedulable
        }
      />
    </Modal>
  );
};
